import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/app.state';
import { AgGridConfig } from '../../store/ag-grid-config/ag-grid-config.reducer';
import { selectAgGridConfigForTable } from '../../store/ag-grid-config/ag-grid-config.selectors';
import { FormControl, FormGroup } from '@angular/forms';
import { FilterDateStartEnd } from 'src/app/shared/models/filter-datepicker-start-end';

@Component({
  standalone: false,
  selector: 'app-ag-grid-options',
  templateUrl: './ag-grid-options.component.html',
  styleUrls: ['./ag-grid-options.component.scss'],
})
export class AgGridOptionsComponent implements OnInit {
  @Input() showQuickFilter: boolean = true;
  @Input() showColumnsDropdown: boolean = true;
  @Input() configStoreTableName!: string;
  @Input() configStoreRouteIdName: string | undefined;
  @Input() disableColumnSizeStrategies: boolean = false;
  @Input() disableExportToCsv: boolean = false;
  @Input() tagsMode: boolean = false;
  @Input() showDateFilter: boolean = false;

  @Output() filterDateChanged = new EventEmitter<FilterDateStartEnd>();
  
  tableConfig$!: Observable<AgGridConfig>;

  readonly filterDates = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  
  public constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.tableConfig$ = this.store.select(
      selectAgGridConfigForTable(
        this.configStoreTableName,
        this.configStoreRouteIdName ?? ''
      )
    );
  }

  clearDates() {
    this.filterDates.reset();
    const FilterDateStartEndReset = {startDate: null, endDate: null};
    this.filterDateChanged.emit(FilterDateStartEndReset);
  }

  onFilterDatesChanged() {
    const startDate = this.filterDates.controls.start.value!;
    const endDate = this.filterDates.controls.end.value!;
    if (!startDate || !endDate) {
      return;
    }
    
    const filterDateRange: FilterDateStartEnd = {
      startDate: startDate,
      endDate: endDate
    };
    
    this.filterDateChanged.emit(filterDateRange);
  }
}
